import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function StudentDashboard(props) {
  document.title = props.title;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));


  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [feedbackVisibilityDetails, setFeedbackVisibilityDetails] = useState("");
  const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");
  const [studentClassSemester, setStudentClassSemester] = useState(userLoginDetails.mstr_student_class_semester);
  // console.log('userDetailsLog: ', userLoginDetails);
  const navigate = useNavigate();

  useEffect(() => {
    getFeedbackVisibility();
    getFeedbackSubmittedStatus(userLoginDetails.mstr_student_class_semester);
  }, []);

  function getFeedbackSubmittedStatus(value) {
    setStudentClassSemester(value);
    axios.post(config.API_URL + 'getSubmittedFeedbackDetails', {
      userId: userLoginDetails.LoginUserId,
      userRole: userLoginDetails.role_master_auto_id,
      currentAcademicYear: userLoginDetails.currentAcademicYear,
      classSemester: value
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setSubmittedFeedbackDetails(response.data.data);
        } else {
          setSubmittedFeedbackDetails("");
        }
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function getFeedbackVisibility() {
    axios.post(config.API_URL + 'getFeedbackVisibilityDetails', {
      userRole: userLoginDetails.role_master_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setFeedbackVisibilityDetails(response.data.data);
        } else {
          setFeedbackVisibilityDetails("");
        }
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function onFeedbackSelectSubmitClick(feedbackLink) {
    // console.log(feedbackLink);
    localStorage.setItem("selectedStudentClassSemester", studentClassSemester);
    navigate(feedbackLink);
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;[&nbsp;{userLoginDetails.courseName}&nbsp;]</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Student Feedback</div>
          </div>
          </div>
        </section>

        <section className='section-userInformation'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='note note-thankyou'>
                <span style={{ display: 'block', marginBottom: '10px' }}>Dear Students,  </span>We would greatly appreciate your feedback about the college. This will help us to strengthen the college programmes and infrastructure. We request to read the questions carefully answer Your identity and responses will be kept confidential. </div>
            </div>
          </div>
          <div className='row'>
            <div className="form-group col-md-4">
              <label htmlFor="name">Program  <em>*</em></label>
              <select className="form-control" disabled>
                <option value={userLoginDetails.courseName}>{userLoginDetails.courseName}</option>
              </select>

            </div>
            <div className="form-group col-md-4">
              <label>Semester currently studying in  <em>*</em></label>
              <select className="form-control" disabled onChange={(e) => getFeedbackSubmittedStatus(e.target.value)} value={studentClassSemester}>
                {
                  userLoginDetails.classSemester.split(',').map((val) => (
                    <option value={val}>{val}</option>
                  ))
                }
              </select>
            </div>
          </div>

          <div className='row'>
            <div className='row-feedbackbox '>

              {
                feedbackVisibilityDetails.split(',').includes('Infrastructure') == true ?
                  (submittedFeedbackDetails.split(',').includes('Infrastructure') == false ?
                    <div className="col-md-4">
                      <div className='box-feedback' >
                        <span className='number'>1</span><h4><span> Feedback on </span>Academic Performance and Ambiance  </h4>
                        <button className='btn btn-primary' onClick={() => onFeedbackSelectSubmitClick('/StudentInfrastructureFeedback')} ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} >Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Academic Performance and Ambiance</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

              {
                feedbackVisibilityDetails.split(',').includes('Course Transaction') == true ?
                  (submittedFeedbackDetails.split(',').includes('Course Transaction') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>2</span><h4> <span>Feedback on </span>Curriculum/ Syllabus/ Course Transition</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/CourseTransactionFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Curriculum/ Syllabus/ Course Transition</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

              {
                feedbackVisibilityDetails.split(',').includes('SSS') == true ?
                  (submittedFeedbackDetails.split(',').includes('SSS') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>3</span><h4> <span>Feedback on </span>Student Satisfaction Survey(SSS)</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/SSSFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on SSS</span>Student Satisfaction Survey</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }
            </div>

            <div className='row-feedbackbox'>
              {
                feedbackVisibilityDetails.split(',').includes('Teacher') == true ?
                  (submittedFeedbackDetails.split(',').includes('Teacher') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>4</span><h4> <span>Feedback on </span>Student on Teacher</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/StudentTeacherFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>STudent on Teacher</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }
              
              {
                feedbackVisibilityDetails.split(',').includes('Programme') == true ?
                  (submittedFeedbackDetails.split(',').includes('Programme') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>5</span><h4> <span>Feedback on </span>Programme</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/ProgrammeFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Programme</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

              {
                feedbackVisibilityDetails.split(',').includes('Academic') == true ?
                  (submittedFeedbackDetails.split(',').includes('Academic') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>6</span><h4> <span>Feedback on </span>Academic</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/AcademicFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Academic</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

            </div>
          </div>
        </section>
        <section className='section-footer'>
          <div className='row'><div className='col-md-12'><div className='footer col-md-6'>{config.collegeName}, Feedback System {config.version}</div>
            <div className='footer col-md-6' style={{ textAlign: 'right' }}>{config.PoweredBy}</div>
          </div></div>
        </section>
      </div>
      <ToastContainer />
    </div>
  )
}